var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.76947 8.04862C4.76947 8.04862 6.76803 6.05006 8.04862 4.76947M4.76947 4.76947C4.76947 4.76947 6.76803 6.76803 8.04862 8.04862M6.90329 1.16804C6.68056 0.945303 6.32207 0.942677 6.09671 1.16804L1.16804 6.09671C0.945303 6.31944 0.942677 6.67793 1.16804 6.90329L6.09671 11.832C6.31944 12.0547 6.67793 12.0573 6.90329 11.832L11.832 6.90329C12.0547 6.68056 12.0573 6.32207 11.832 6.09671L6.90329 1.16804Z",
    stroke: "#FF0C0C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobFailure);
export default __webpack_public_path__ + "static/media/Job Failure.2259dea60591a2988e2121c53a32a537.svg";
export { ForwardRef as ReactComponent };